import React from 'react';
import DeleteTraitDialog from './traits-dialogs/DeleteTraitDialog';

function TraitDialogs() {
  return (
    <>
      <DeleteTraitDialog />
    </>
  );
}

export default TraitDialogs;
